import React from 'react';

import {cx} from 'emotion';
import PropTypes from 'prop-types';

import {divAsBorderStyle, listItemStyle, selectedStyle} from './style';

const propTypes = {
  additionalClassName: PropTypes.string,
  isHighlighted: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  onMouseEnter: PropTypes.func
};

export const NavMenuListItem = (props) => {
  const {isHighlighted, children, additionalClassName} = props;

  /**
   * For accessibility, we cannot have a blue border against a blue background
   * which could potentially occur on some pages. To avoid this, we added a div
   * with a blue background 4px away from the left margin of the <li> to give the colors
   * some breathing room.
   */
  const divAsBorder = () => {
    return isHighlighted ? <div className={divAsBorderStyle} /> : null;
  };

  return (
    <li
      className={cx([listItemStyle,
        isHighlighted && selectedStyle,
        additionalClassName
      ])}
      onMouseEnter={props.onMouseEnter}
    >
      {divAsBorder()}
      {children}
    </li>
  );
};

NavMenuListItem.propTypes = propTypes;

export default NavMenuListItem;
